import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    FormControl,
    InputLabel,
    InputBase,
    Typography,
    Button,
    Checkbox,
    Fade,
    CircularProgress,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    MenuList,
    MenuItem,
    DialogTitle,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import CustomizedTable from 'mdoc/utils/table';
import { dictionary, getlangId } from '../../axios';
import { getDepartmentSearch, getUserSearch } from 'mdoc/admin/axios/user'
import { contentApplyUserList, contentSaveApplyUser, downloadUserCSV, contentDeleteApplyUser } from '../../axios/content';
import Toast from 'mdoc/utils/toast';
import Dialog from 'mdoc/utils/myDialog';
import { Link } from 'react-router-dom';
import { messageFormat, dateFormat } from 'mdoc/utils';

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapFormLabel: {
        lineHeight: '30px',
    },
    spanBox: {
        lineHeight: '30px'
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    buttonProgress: {
        color: '#ff0000',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
        opacity: 0.5,
        zIndex: 999,
    },
    tags: {
        margin: theme.spacing.unit,
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none'
    },
    item: {
        color: '#ffffff',
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    title: {
        marginLeft: '-20px'
    },
});


class Content_UserEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dictWord: {
                'department_user_edit': '',
                'published_department': '',
                'published_user': '',
                'category_first_level': '',
                'category_second_level': '',
                'category_three_level': '',
                'category_four_level': '',
                'category_five_level': '',
                'add_record': '',
                'delete_record': '',
                'save_record': '',
                'csv_export': '',
                'csv_import': '',
                'cancel': '',
                'user_code': '',
                'contact_person_name': '',
                'mail_address': '',
                'set_lang': '',
                'device_control': '',
                'invalid': '',
                'valid': '',
                'msg_confirm_really_delete': '',
                'msg_error_no_record_selected': '',
                'msg_error_upload_file_type_invalid': '',
                'msg_error_not_null_with_item': '',
                'dimension_no': '',
                'user_id': '',
                'user_name': '',
                'judge': '',
                'error_detail': '',
                'upload_filename': '',
                'upload_result': '',
                'count': '',
                'failed_count': '',
                'upload_detail': '',
                'department_specified_release': '',
                'department_search': '',
                'user_search': '',
                'department_designation': '',
                'msg_error_record_exists': '',
                'department': '',
                'msg_save_success': '',
                'reader': '',
                close:''
            },
            name: '',
            langIdData: {},
            checkData: [],
            dialogCheckedDelete: false,
            dialogErrorOpen: false,
            dialogOpenSearchUser: false,
            dialogOpenDepartmentSearch: false,
            okLoading: false,
            saveDetailDataFlag: true,
            pagination: {
                pageNumber: 1,
                pageSize: 0,
                count: 0,
                sidx: '',
                sord: ''
            },
            applyId: parseInt(this.props.match.params.id),
            departmentInfo: {},
            applyEffectiveReceive: [],
            detailData: [],
            errorList: [],
            errorCount: 0,
            uploadCount: 0,
            department: [],
            user: [],
            selectUser: [],
        }
    };
    componentWillMount() {
        let dict = {}
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        });
        getlangId().then(res => {
            let langIdData = this.state.langIdData
            let data = res.results
            for (let key in data) {
                let val = data[key];
                langIdData[val.id] = val.name;
            }
            this.setState({
                langIdData
            })
        })
        this.fetch();
    }

    fetch(params = {}) {
        let pagination = '';
        if (params.pageSize) {
            pagination = params
        } else {
            pagination = this.state.pagination
        }
        this.setState({
            okLoading: true,
        })
        let { applyId, departmentInfo, detailData, applyEffectiveReceive } = this.state;
        contentApplyUserList({ applyId, ...pagination }).then(res => {
            departmentInfo.publisher = res.docTblApply.publisher;
            departmentInfo.author = res.docTblApply.author;
            departmentInfo.categoryDepth1Name = res.docTblApply.categoryDepth1Name || '';
            departmentInfo.categoryDepth2Name = res.docTblApply.categoryDepth2Name || '';
            departmentInfo.categoryDepth3Name = res.docTblApply.categoryDepth3Name || '';
            departmentInfo.categoryDepth4Name = res.docTblApply.categoryDepth4Name || '';
            departmentInfo.categoryDepth5Name = res.docTblApply.categoryDepth5Name || '';
            if (res.docTblApply.applyEffectiveReceive && res.docTblApply.applyEffectiveReceive.length > 0) {
                applyEffectiveReceive = res.docTblApply.applyEffectiveReceive;
            }
            if (res.docTblApplyUserList && res.docTblApplyUserList.length > 0) {
                detailData = res.docTblApplyUserList.map(item => {
                    return item.docTblUser
                });
            }
            this.setState({
                applyEffectiveReceive,
                departmentInfo,
                detailData,
                pagination,
                okLoading: false,
            });
        });
    }

    heanderDeleteData() {
        let { checkData, dictWord } = this.state;
        if (checkData.length <= 0) {
            Toast.error(dictWord.msg_error_no_record_selected);
            return;
        } else {
            this.setState({
                dialogCheckedDelete: true,
            })
        }
    }

    handleChangeChecked(rowId) {
        let { checkData } = this.state;
        let index = checkData.indexOf(rowId);
        if (index >= 0) {
            checkData.splice(index, 1);
        } else {
            checkData.push(rowId);
        }
        this.setState({
            checkData,
        })
    }

    heanderAddData() {
        this.setState({
            dialogOpenSearchUser: true,
            show: false,
            name: '',
        })
    }

    heanderSaveData() {
        this.setState({
            okLoading: true,
        })
        let { detailData, applyId, applyEffectiveReceive, departmentInfo, dictWord } = this.state;
        let applyEffectiveReceives = [];
        applyEffectiveReceive.forEach(item => {
            applyEffectiveReceives.push({
                docTblApplyDepartmentPK: {
                    applyId,
                    departmentId: item.docMstDepartment.id,
                }
            })
        })
        let docTblApplyUserList = [];
        detailData.forEach(item => {
            let docTblApplyUserPK = {
                applyId,
                userId: item.id
            };
            docTblApplyUserList.push(
                {
                    docTblApplyUserPK,
                    docTblUser: item,
                }
            )
        })
        let list = {
            docTblApply: {
                id: applyId,
                applyEffectiveReceive: applyEffectiveReceives,
                publisher: departmentInfo.publisher,
                author: departmentInfo.author,
            },
            docTblApplyUserList,
        };
        contentSaveApplyUser(list).then(res => {
            if (!res.error) {
                this.setState({
                    saveDetailDataFlag: true,
                })
                Toast.success(dictWord.msg_save_success);
                this.props.history.push('/admin/content/contentread');
            }
        }).catch(function (err) {
            Toast.error(err);
            this.setState({
                okLoading: false,
            })
        })
    }

    dialogHandleOK() {
        let { checkData, detailData, applyId } = this.state;
        this.setState({
            okLoading: true,
        })
        let docTblApplyUserList = [];
        detailData.forEach((item, index) => {
            let docTblApplyUserPK = {
                applyId,
                userId: item.id
            };
            checkData.forEach(value => {
                if (item.id && value === index) {
                    item.operationFlg = 3;
                    item.delFlg = 1;
                    docTblApplyUserList.push(
                        {
                            docTblApplyUserPK,
                            docTblUser: item,
                        }
                    )
                }
            });
        })
        let list = {
            docTblApplyUserList,
            docTblApply: {
                id: applyId,
            },
        };
        contentDeleteApplyUser(list).then(res => {
            if (!res.error) {
                this.setState({
                    detailData: [],
                    okLoading: false,
                    dialogCheckedDelete: false,
                    checkData: [],
                });
                this.fetch();
            }
        }).catch(function (err) {
            Toast.error(err);
            this.setState({
                okLoading: false,
            })
        })
    }

    dialogHandleClose() {
        this.setState({
            dialogCheckedDelete: false,
            dialogErrorOpen: false,
            dialogOpenSearchUser: false,
            dialogOpenDepartmentSearch: false,
            selectUser: [],
        });
    }

    downloadUserCSV() {
        let { applyId, dictWord } = this.state;
        let csvName = dictWord.reader + dateFormat(new Date(), 'yyyyMMddhhmmss');
        downloadUserCSV({ applyId, csvName }).then(res => { }).catch(function (error) {
            Toast.error(error);
        })
    }

    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';
        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    };

    handleDelTags = (tagid) => event => {
        let { applyEffectiveReceive } = this.state;
        applyEffectiveReceive.splice(tagid, 1);
        this.setState({
            applyEffectiveReceive,
            saveDetailDataFlag: false,
        })
    }

    inputHandleSearchUser(event){
        this.setState({
            name: event.target.value
        },()=>{
            getUserSearch({
                'name': this.state.name,
            }).then(res => {
                this.setState({
                    show: true
                })
                const user = res.results;
                let userList = [];
                for (var key in user) {
                    let value = user[key];
                    value.selectFlag = false;
                    userList.push(value);
                }
                this.setState({
                    user: userList
                })
            }).catch(function (error) {
                Toast.error(error);
            })
        });
    }

    inputHandleSearchDepartment (event){
        this.setState({
            name: event.target.value
        },()=>{
            getDepartmentSearch({
                'departmentName': this.state.name,
            }).then(res => {
                this.setState({
                    show: true
                })
                const department = res.results;
                let dep = [];
                for (var key in department) {
                    let value = department[key];
                    dep.push({
                        id: value['id'],
                        departmentName: value['departmentName'],
                    });
                }
                this.setState({
                    department: dep
                })
            }).catch(function (error) {
                Toast.error(error);
            })
        });
    }

    handleToggle(item) {
        let { selectUser } = this.state;
        if (!item.selectFlag) {
            item.selectFlag = true;
            selectUser.push(item)
        } else {
            item.selectFlag = false;
            selectUser.splice(item, 1)
        }
        this.setState({
            selectUser,
        })
    }

    handleDepartmentSearch() {
        this.setState({
            dialogOpenDepartmentSearch: true,
            show: false,
            name: '',
            department: []
        });
    }

    handleSearchValue = (column) => (event) => {
        let { applyEffectiveReceive } = this.state;
        let isSame = false;
        applyEffectiveReceive.forEach(item => {
            if (item.docMstDepartment.id === column.id) {
                isSame = true;
                return;
            }
        })
        if (isSame) {
            Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.department));
        } else {
            let docMstDepartment = {};
            docMstDepartment.docMstDepartment = column;
            applyEffectiveReceive.push(docMstDepartment);
            this.setState({
                applyEffectiveReceive,
                dialogOpenDepartmentSearch: false,
                saveDetailDataFlag: false,
            })
        }
    }

    dialogHandleUserOK() {
        let { selectUser, detailData, dictWord } = this.state;
        if (selectUser.length > 0) {
            let idArr = [];
            for (let j = 0; j < detailData.length; j++) {
                idArr.push(detailData[j].id);
            }
            for (let i = 0; i < selectUser.length; i++) {
                let value = selectUser[i];
                let index = idArr.indexOf(value.id);
                if (index < 0) {
                    detailData.push(value)
                } else {
                    Toast.info(messageFormat(dictWord.msg_error_record_exists, dictWord.user_id));
                    return;
                }
            }
            this.setState({
                detailData,
                selectUser: [],
                dialogOpenSearchUser: false,
                saveDetailDataFlag: false,
            });
        } else {
            this.setState({
                selectUser: [],
                dialogOpenSearchUser: false
            });
        }
    }

    render() {
        const { classes } = this.props;
        let { dictWord, detailData, departmentInfo, applyEffectiveReceive } = this.state;
        const columnsDetail = [
            {
                title: '',
                width: '90px',
                toolTipDisabled: true,
                render: (text, record, rowId) => {
                    let { checkData } = this.state;
                    return (
                        <Checkbox
                            className={classes.Checkbox}
                            checked={checkData.indexOf(rowId) >= 0}
                            onClick={this.handleChangeChecked.bind(this, rowId)}
                        />
                    );
                }
            },
            {
                title: this.state.dictWord.user_code,
                dataIndex: 'userCode',
                sorter: true,
                validate: { required: dictWord.msg_error_not_null_with_item },
            },

            {
                title: this.state.dictWord.contact_person_name,
                dataIndex: 'name',
                sorter: true,
            },
            {
                title: this.state.dictWord.mail_address,
                dataIndex: 'email',
                sorter: true,
            },
            {
                title: this.state.dictWord.set_lang,
                dataIndex: 'langId',
                type: 'select',
                datasource: this.state.langIdData,
                width: '90px',
            },
            {
                title: this.state.dictWord.device_control,
                dataIndex: 'deviceControl',
                type: 'select',
                datasource: { 0: this.state.dictWord.invalid, 1: this.state.dictWord.valid },
                width: '90px',
            },
        ];
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {dictWord.published_department}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputLabel className={classes.spanBox}>
                            {departmentInfo.publisher}
                        </InputLabel>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {dictWord.published_user}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {departmentInfo.author}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {dictWord.category_first_level}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {departmentInfo.categoryDepth1Name}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {this.state.dictWord.category_second_level}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {departmentInfo.categoryDepth2Name}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {this.state.dictWord.category_three_level}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {departmentInfo.categoryDepth3Name}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {this.state.dictWord.category_four_level}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {departmentInfo.categoryDepth4Name}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {this.state.dictWord.category_five_level}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {departmentInfo.categoryDepth5Name}
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="departmentSpecified">
                            {dictWord.department_specified_release}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <div style={{ border: '1px solid #ccc', minHeight: '55px', padding: '5px' }}>
                                {applyEffectiveReceive.map((column, j) => {
                                    return <Button key={j} variant="outlined" color="primary" className={classes.tags}>
                                        {column.docMstDepartment.departmentName}
                                        <Close fontSize="inherit" color="action" onClick={this.handleDelTags(j)} />
                                    </Button>
                                })}
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" onClick={this.handleDepartmentSearch.bind(this)} className={classes.margin} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }}>
                            {dictWord.department_search}
                        </Button>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={12}>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.heanderAddData.bind(this)}>{this.state.dictWord.add_record}</Button>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.heanderDeleteData.bind(this)}>{this.state.dictWord.delete_record}</Button>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.heanderSaveData.bind(this)} disabled={this.state.saveDetailDataFlag}>{this.state.dictWord.save_record}</Button>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.downloadUserCSV.bind(this)}>{this.state.dictWord.csv_export}</Button>
                        <Link to="/admin/content/contentread" className={classes.link}>
                            <Button variant="contained" color="primary" className={classes.margin}>{this.state.dictWord.cancel}</Button>
                        </Link>
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={detailData}
                        columns={columnsDetail}
                        noPage
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
                <Fade
                    in={this.state.okLoading}
                    style={{
                        transitionDelay: this.state.okLoading ? '800ms' : '0ms',
                    }}
                    unmountOnExit
                >
                    <CircularProgress size={24} className={classes.buttonProgress} />
                </Fade>
                <Dialog
                    open={this.state.dialogCheckedDelete}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    content={<p>{dictWord.msg_confirm_really_delete}</p>}
                    okLoading={this.state.okLoading}
                    handleOk={this.dialogHandleOK.bind(this)}
                    handleClose={this.dialogHandleClose.bind(this)}
                />

                <Dialog
                    open={this.state.dialogOpenDepartmentSearch}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        maxWidth: false
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['department_search']}</DialogTitle>}
                    content={
                        <div>
                            <div className={classes.margin}>
                                <div>
                                    <InputLabel shrink htmlFor="name" className={classes.bootstrapFormLabel}>
                                        {dictWord.department_designation}
                                    </InputLabel>
                                </div>
                                <div>
                                    <InputBase
                                        style={{minWidth:'265px'}}
                                        id="name"
                                        value={this.state.name}
                                        fullWidth
                                        inputProps={{
                      autoComplete:"off"
                    }}
                                        onChange={this.inputHandleSearchDepartment.bind(this)}
                                        onFocus={this.inputHandleSearchDepartment.bind(this)}
                                        classes={{
                                            root: classes.bootstrapRoot,
                                            input: classes.bootstrapInput,
                                        }}
                                    />
                                    {this.state.show ? <Paper className={classes.paper}>
                                        <MenuList>
                                            {this.state.department.map((column, j) => {
                                                return <MenuItem key={j} style={{minWidth:'230px'}} onClick={this.handleSearchValue(column)}>{column.departmentName}</MenuItem>
                                            })}
                                        </MenuList>
                                    </Paper> : null}
                                </div>
                            </div>
                        </div>
                    }
                    handleClose={this.dialogHandleClose.bind(this)}
                />

                <Dialog
                    open={this.state.dialogOpenSearchUser}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        ok: {
                            text: this.state.dictWord['ok'],
                        },
                        maxWidth:false
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['user_search']}</DialogTitle>}
                    content={
                        <div>
                            <div className={classes.margin}>
                                <div className={classes.bootstrapFormLabel}>
                                    <InputLabel shrink htmlFor="name">
                                        {dictWord.user_name}
                                    </InputLabel>
                                </div>
                                <div>
                                    <InputBase
                                        style={{ minWidth: '265px' }}
                                        id="name"
                                        value={this.state.name}
                                        fullWidth
                                        inputProps={{
                      autocomplete:"off"
                    }}
                                        onChange={this.inputHandleSearchUser.bind(this)}
                                        onFocus={this.inputHandleSearchUser.bind(this)}
                                        classes={{
                                            root: classes.bootstrapRoot,
                                            input: classes.bootstrapInput,
                                        }}
                                    />
                                    {this.state.show ? <Paper className={classes.paper}>
                                        <List dense component="div" role="list" >
                                            {
                                                this.state.user.map(value => {
                                                    return (
                                                        <ListItem role="listitem" button key={value.id} style={{ minWidth: '230px' }}>
                                                            <ListItemIcon onClick={this.handleToggle.bind(this, value)}>
                                                                <Checkbox
                                                                    disableRipple
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText primary={value.name} />
                                                        </ListItem>
                                                    )
                                                })
                                            }
                                            <ListItem />
                                        </List>
                                    </Paper> : null}
                                </div>
                            </div>
                        </div>
                    }
                    handleOk={this.dialogHandleUserOK.bind(this)}
                    handleClose={this.dialogHandleClose.bind(this)}
                />

            </div>
        )

    }
}

Content_UserEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content_UserEdit);